window.addEventListener("load", function () {
  setTimeout(function () {
    const header = document.querySelector('.site-control__inner');
    if (header) {
      header.style.setProperty("padding-top", "25px", "important");
      header.style.setProperty("padding-bottom", "25px", "important");
      header.style.setProperty("height", "auto", "important");
      header.style.setProperty("overflow", "visible", "important");
    }
  }, 500);
});
